import { io, Socket } from 'socket.io-client';

function getApiBaseUrl(): string {
  // Android emulator needs 10.0.2.2 to reach host machine
  if ((window as any)?.Capacitor?.getPlatform?.() === 'android') {
    return 'http://10.0.2.2:3000/api';
  }

  // Web / everything else
  return import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000/api';
}

const baseSocketURL = getApiBaseUrl();

// Helper to create socket instances with shared config
// const createSocket = (namespace: string) => {
//   return io(`${baseSocketURL}${namespace}`, {
//     withCredentials: true,
//     transports: ['websocket'],
//     autoConnect: false,
//   });
// };

const createSocket = (namespace: string) => {
  const url = `${baseSocketURL}${namespace}`;
  console.log('[Socket] Connecting to:', url);

  const s = io(url, {
    withCredentials: true,
    transports: ['websocket'],
    autoConnect: false,
  });

  s.on('connect', () => console.log(`[Socket] ${namespace} connected:`, s.id));
  s.on('connect_error', (err) =>
    console.log(`[Socket] ${namespace} error:`, err.message),
  );

  return s;
};

export const notificationSocket: Socket = createSocket('/notifications');
export const locationSocket: Socket = createSocket('/location');

export const connectSockets = () => {
  if (!notificationSocket.connected) notificationSocket.connect();
  if (!locationSocket.connected) locationSocket.connect();
};

export const disconnectSockets = () => {
  notificationSocket.disconnect();
  locationSocket.disconnect();
};
